import { IComposedFilter } from "domain/Utils";
import { useFilterToQueryString } from "hooks/useFilterToQueryString/indext";
import { useRequest } from "hooks/useRequest";
import { IPurchasePlan } from "../models/IPurchasePlans";
import { transformFilters } from "modules/SystemContext/hooks/useSystemContextRequester";

export const usePurchasesRequester = () => {
	const request = useRequest("purchase");
	const { fetchQueryString } = useFilterToQueryString();

	const toSystmeFilter = (obj: IComposedFilter) => {
		const filter = obj.filter ?? [];

		const products = {
			product: filter
				.filter((p) => p.type === "product")
				.map((p) => p.name),
		};

		const stores = {
			store: filter.filter((p) => p.type === "store").map((p) => p.name),
		};

		const groupedCategories = filter
			.filter((p) => p.type === "category")
			.groupBy((p: any) => p.deep);

		const categories = {} as { [key: string]: string[] };

		Object.keys(groupedCategories).flatMap((c) => {
			categories["category " + c] = groupedCategories[c].map(
				(d: any) => d.name,
			);
		});

		return { ...products, ...stores, ...categories };
	};

	const fetchPurchase = (filter: IComposedFilter) => {
		return request
			.POST("recommend", { tags: toSystmeFilter(filter) })
			.then((result) => {
				const purchasePlans = result.data.map(
					(plan: IPurchasePlan) => ({
						...plan,
						modifier: plan.modifier ?? 0,
					}),
				);

				return purchasePlans as IPurchasePlan[];
			});
	};

	return {
		fetchPurchase,

		fetchRecomendation: (queryFilters: any) => {
			const query = fetchQueryString({
				emergencial: queryFilters.emergencial!,
				tag:
					queryFilters.tag !== btoa("Alerts")
						? queryFilters.tag!
						: "",
				tagType: queryFilters.tagType!,
			});

			return request
				.GET(`${queryFilters.tagType}${query}`)
				.then((result) => {
					return result.data as IPurchasePlan[];
				});
		},

		runOnDemand: (filter: IComposedFilter) => {
			const products = filter?.filter?.filter(
				(c: any) => c.type === "product",
			);
			const categories = filter?.filter?.filter(
				(c: any) => c.type === "category",
			);
			const stores = filter?.filter?.filter(
				(c: any) => c.type === "store",
			);

			return request.POST(`purchaseOnDemand`, {
				products,
				categories,
				stores,
			});
		},

		fetchFilteredRecomendation: (filter: any) => {
			return request.POST(`purchase`, filter || {}).then((result) => {
				return result.data as IPurchasePlan[];
			});
		},

		fetchComposedFilteredRecomendationCount: (filter: IComposedFilter) => {
			const tagNames =
				filter.filter
					?.filter((c) => c.type == "tag")
					.map((c) => c.name) ?? [];

			const builtFilter = transformFilters({
				products:
					filter.filter?.filter((c) => c.type == "product") ?? [],
				stores: filter.filter?.filter((c) => c.type == "store") ?? [],
				categories:
					filter.filter?.filter((c) => c.type == "category") ?? [],
			});

			return request
				.POST(`purchaseCount`, { ...builtFilter, tags: tagNames })
				.then((result) => {
					return result.data as any;
				});
		},

		fetchComposedFilteredRecomendation: (
			filter: IComposedFilter,
			skip: number = 0,
			take: number = 100,
		) => {
			const tagNames =
				filter.filter
					?.filter((c) => c.type == "tag")
					.map((c) => c.name) ?? [];

			const builtFilter = transformFilters({
				products:
					filter.filter?.filter((c) => c.type == "product") ?? [],
				stores: filter.filter?.filter((c) => c.type == "store") ?? [],
				categories:
					filter.filter?.filter((c) => c.type == "category") ?? [],
			});

			const params = new URLSearchParams();
			params.append("skip", skip.toString());
			params.append("take", take.toString());

			return request
				.POST(`purchase?${params.toString()}`, {
					...builtFilter,
					tags: tagNames,
				})
				.then((result) => {
					return result.data as IPurchasePlan[];
				});
		},
	};
};
